import './bootstrap-lite/css/bootstrap.min.css';
import './css/mediakit.css';
import React, { Component } from 'react';
//import SignUpSplash from './components/media-kit/SignUpSplash';
import NavBar from './components/media-kit/NavBar';
import TopHero from './components/media-kit/TopHero';
import Highlights from './components/media-kit/Highlights';
//import Vlog from './components/media-kit/Vlog';
import HomePage from './components/media-kit/HomePage';
import SpotlightStores from './components/media-kit/SpotlightStores';
import Category from './components/media-kit/Category';
import Video from './components/media-kit/Video';
import Newsletter from './components/media-kit/Newsletter';
/*import SocialMedia from './components/media-kit/SocialMedia';
import Holiday from './components/media-kit/Holiday';*/

class MediaKit extends Component {
  /*constructor(props) {
    super(props);
    this.state = { hasCookie: true };
  }

  componentDidMount() {
    this.setState(
      {
        renderFullSite: [
          <NavBar key={'NavBar'} />,
          <TopHero key={'TopHero'} />,
          <Highlights key={'Highlights'} />,
          <Vlog key={'Vlog'} />,
          <HomePage key={'HomePage'} />,
          <SpotlightStores key={'SpotlightStores'} />,
          <Category key={'Category'} />,
          <Newsletter key={'Newsletter'} />,
          <Video key={'Video'} />
        ]
      }
    );
  }*/

  render() {
    return (
      <div className="app container-fluid">
        {/*this.state.hasCookie ? this.state.renderFullSite : 
          <SignUpSplash />
        */}

        <NavBar />
        <TopHero />
        <Highlights />
        {/* <Vlog /> */}
        <HomePage />
        <SpotlightStores />
        <Category />
        <Newsletter />
        <Video />
        
        {/*<SocialMedia />
        <Holiday />*/}
      </div>
    );
  }
}

export default MediaKit;